import {
  Component,
  OnInit,
  HostListener,
  OnDestroy
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { filter, map, mergeMap } from "rxjs/operators";
import { LoaderService } from "../../services";
import { LocalStorageService } from "./../../../shared/services/local-storage.service";
import { PageDataService } from "./page-data.service";
import { SettingsConstant } from "./../../../shared/constants/settings.constants";
import { PermissionUrlService } from "../../../shared/services/permissions.service";
import { CommonService } from './../../../shared/services/common.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from "../../services/login.service"

// Not in use
// const widgetPermission = new PermissionUrlService();

const MOBILE_SCREEN = 840;

import { NgxPermissionsService } from "ngx-permissions";

@Component({
  selector: "layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"]
})
export class LayoutComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  currentPageTitle: string = "";
  setLayout: boolean = true;
  collapseSidebar: boolean = true;
  public centerList: Array<string>;
  selectedCenterName;
  isCollapseSidebarOpen;
  userProfie: any = {};
  currentClient;
  clientDetails;
  profileName;
  a = false;
  profileImage = null;
  permissionsFound = false;
  // Not in use
  // requiredPermission = [
  //   ...widgetPermission.OVERALL_PERFORMANCE_TAB_DELHIVERY,
  //   ...widgetPermission.OVERALL_PERFORMANCE_TAB_INWARD,
  //   ...widgetPermission.OVERALL_PERFORMANCE_TAB_TRANSFER,
  //   ...widgetPermission.OVERALL_PERFORMANCE_TAB_RETURN
  // ]
  @HostListener("window:resize", ["$event"])
  @HostListener("window:load", ["$event"])
  isMobileScreen() {
    return window.innerWidth <= MOBILE_SCREEN ? true : false;
  }

  toggleSidebar() {
    this.collapseSidebar = !this.collapseSidebar;
  }
  collapseSideBar() {
    this.collapseSidebar = true;
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private title: Title,
    private loader: LoaderService,
    private localStorage: LocalStorageService,
    private commonService: CommonService,
    private pageDataService: PageDataService,
    private permissionService: NgxPermissionsService,
    private loginService : LoginService
  ) {
    this.getRouteParams();
  }

  ngOnInit() {
    this.getProfileAndClientDetail();
  }

  getProfile() {
    this.loader.start();
    this.commonService.getSelfProfile().pipe(takeUntil(this.unsubscribe)).subscribe((res) => {
      this.loader.stop();
      if (res) {
        Object.keys(this.userProfie).forEach(ele => {
          if (!res[ele] && this.userProfie[ele]) {
            res[ele] = this.userProfie[ele];
          }
        });
        this.localStorage.setItem(`${SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS}`, res);
        this.profileName = res['first_name']
          ? `${res['first_name']} ${res['last_name'] ? res['last_name'] : ''}`
          : null;
      }
    }, (err) => {
      this.loader.stop();
    })
  }

  getProfileAndClientDetail() {
    const userDetail = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.USER_DETAILS
    );
    this.userProfie = userDetail;
    if (!this.userProfie.first_name) {
      this.getProfile();
    } else {
      this.profileName = userDetail.first_name
        ? `${userDetail.first_name} ${userDetail.last_name ? userDetail.last_name : ''}`
        : null;
    }
    this.profileImage = userDetail.picture ? userDetail.picture : './../../../../assets/images/user_logo.png';
    this.clientDetails = this.localStorage.getItem(
      SettingsConstant.LOCALSTORAGE_KEYS.CLIENT_LIST
    );
    if (this.clientDetails) {
      this.clientDetails = JSON.parse(this.clientDetails).map((data) => {
        data["client_name"] = data["meta_data"] && data["meta_data"]["name"] ? data["meta_data"]["name"] : "Unknown";
        return data;
      });
    }
    this.currentClient = this.localStorage.getItem(SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT);
  }

  changeCurrentClient(id) {
    this.localStorage.setItem(
      SettingsConstant.LOCALSTORAGE_KEYS.SELECTED_CLIENT, this.currentClient
    );
    if (location.href.indexOf("?") > -1) {
      location.href = location.href.substr(0, location.href.indexOf("?"));
    }
    location.reload();

  }

  /**
   *
   * @description Method to get title and layout from Data sent when route changes.
   * @var event : has Layout and title. Layout defines whether we need sidebar and navbar.
   *  Title contains the title for page
   *
   **/
  getRouteParams() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter(route => route.outlet === "primary"),
        mergeMap(route => route.data)
      )
      .pipe(takeUntil(this.unsubscribe)).subscribe(event => {
        this.setLayout = event["layout"];
        this.currentPageTitle = event["title"];
        this.title.setTitle(`Delhivery | ${event["title"]}`);
      });
  }

  /**
   *
   * @description Method to handle logout, navigating user back to login page
   *
   **/
  onLogout() {
    // 666 
    this.loginService.logOut();
    // 666 ends
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
